import React, { FC } from 'react';
import MainMenuButton from '~Components/MainMenuButton';
import Icon from '~ComponentsImproved/Icon';
import IconButton from '~ComponentsImproved/IconButton';
import SwapIcon from '~Assets/icons/swap.svg';
import { useDispatch, useI18n, useLicenses, useStaffCan } from '~Hooks';
import { useHistory, useLocation } from 'react-router';
import * as actions from '~actions';

const SidebarButtons: FC = () => {
  const staffCan = useStaffCan();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const licenses = useLicenses();
  const { i18n } = useI18n();

  const showTSRButton = !location.pathname.includes('tables') && licenses.hasTSR;

  return (
    <>
      {showTSRButton && (
        <IconButton
          icon={<Icon src={SwapIcon} color={'var(--colorBlueGray600)'} />}
          text={i18n('POS.TSR')}
          onClick={() => {
            history.push('tables');
          }}
        />
      )}
      {staffCan.openMainMenu ? (
        <IconButton
          icon={<MainMenuButton noBg />}
          onClick={() => {
            dispatch(actions.toggleMainMenu(true));
          }}
        />
      ) : (
        <IconButton
          icon={<MainMenuButton noBg />}
          onClick={() => {
            history.push('gateway');
          }}
        />
      )}
    </>
  );
};

export default React.memo(SidebarButtons);
